module.exports = __webpack_public_path__ + "static/media/Fibra_industrial_vermelha.b487e8be.png";